import React from "react";
import { useField, useFormikContext } from "formik";

export const FileInputField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  return (
    <input
      {...props}
      id={field.name}
      name={field.name}
      type="file"
      accept="application/pdf,application/vnd.ms-excel"
      multiple={props?.multiple ? props?.multiple : false}
      onChange={(event) => {
        if (props?.multiple) {
          setFieldValue(field.name, event.currentTarget.files);
        } else {
          setFieldValue(field.name, event.currentTarget.files[0]);
        }
      }}
      className="form-control"
    />
  );
};

export default FileInputField;
